import React from 'react';
import { useState, useEffect } from 'react' 
import { Link } from 'react-router-dom';
import { db } from '../../../../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot } from 'firebase/firestore';

const ReactJs = ({portfolioData}) => {   
    return (
        <>
            {/* <div className="page-hd clearfix">
                <div className="left-float" style={{marginTop: "0px", marginRight: "20px"}}>
                    <img src="/images/skin1/react-logo.png" /> 
                </div>
                <div className="left-float" style={{marginTop: "10px"}}>
                    <p><strong>Experience: 4 Years</strong></p>
                    <p><strong></strong></p>
                </div>
            </div> */}
            <h1>ReactJS <h3>- 5 Years</h3></h1> 
            <ul>
                <li>- Created modular, reusable react components that are scalable.</li>
                <li>- Experienced in Class based and Function based component creation.</li>
                <li>- Experienced with React Hooks & Custom Hooks. </li>
                <li>- Good understanding on Redux.</li>
                <li>- Experienced integrating React MaterialUI components.</li>
                <li>- Experienced in React form validations.</li>
                <li>- Created custom components like Modal Popup, Alert boxes etc.,</li> 
            </ul>
           {/*  <h3>React Projects</h3><hr /> */}
            {/* <div className="flex-row-container">
              
                {
                    portfolioData.length > 0 ?
                        portfolioData.map((item, index) => {
                            const url = item.data.project_files[0];
                            return ( 
                                    <div className="flex-item card link" key={index}>
                                        <div>
                                            <div className="card-tn" style={{backgroundImage:`url(${url})`, backgroundPosition:'top left'  }}>
                                            </div>
                                            <div className="card-content">
                                                <p className="txt-18 thickest">
                                                {item.data.project_title}
                                                </p>
                                            </div>
                                        </div>
                                    </div> 
                            )
                        }) : <> <div className="loader"></div></>
                } 
            </div>  */}
        </>
        
    )

}
export default ReactJs;